var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#user_svg__clip0_31_3057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 7c1.934 0 3.5-1.566 3.5-3.5S8.934 0 7 0a3.499 3.499 0 00-3.5 3.5C3.5 5.434 5.066 7 7 7zm0 1.75c-2.336 0-7 1.172-7 3.5V14h14v-1.75c0-2.328-4.664-3.5-7-3.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "user_svg__clip0_31_3057"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14v14H0z"
  })))));
}
export default SvgUser;